import { UIButton, UIColor, UIDialogView, UITextView, UIView, YES } from "uicore-ts"
import { RHCompany, RHUserProfilePrivate } from "./SocketClientFunctions"
import { populatedValueOfReference } from "./Core/RHReference"

export class RHAdminDetailsDialog extends UIDialogView {
    
    private readonly scrollView: UIView
    private readonly contentTextView: UITextView
    private readonly closeButton: UIButton
    
    constructor(elementID?: string) {
        super(elementID)
        
        this.view.configureWithObject({
            style: {
                backgroundColor: UIColor.whiteColor.stringValue,
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
            }
        })
        
        this.scrollView = new UIView().addedAsSubviewToView(this.view)
        
        this.contentTextView = new UITextView().addedAsSubviewToView(this.scrollView).configuredWithObject({
            style: {
                color: UIColor.blackColor.stringValue,
                fontSize: "16px",
                lineHeight: "1.5"
            }
        })
        
        this.closeButton = new UIButton().addedAsSubviewToView(this.view).configuredWithObject({
            colors: {
                titleLabel: { normal: UIColor.whiteColor, highlighted: UIColor.greyColor },
                background: { normal: UIColor.blueColor, highlighted: UIColor.colorWithRGBA(0, 0, 200) }
            },
            contentPadding: 10
        })
        this.closeButton.titleLabel.text = "Close"
        
        // noinspection JSConstantReassignment
        this.closeButton.controlEventTargetAccumulator.PrimaryActionTriggered = () => {
            this.dismiss(YES)
        }
    }
    
    public configureForDataItem(dataItem: { user?: RHUserProfilePrivate, company?: RHCompany }) {
        let content = ""
        
        if (dataItem.company) {
            const c = dataItem.company
            content += `<strong>Company Name:</strong> ${c.name}<br>`
            content += `<strong>Registry Code:</strong> ${c.businessRegistryCode}<br>`
        }
        else if (dataItem.user) {
            const u = dataItem.user
            content += `<strong>E-posti aadress:</strong> ${u.email}<br>`
            content += `<strong>Name:</strong> ${u.contactInformation?.name || "N/A"}<br>`
            content += `<strong>Status:</strong> ${u.isDeactivated ? "Deactivated" : "Active"}<br>`
            content += `<strong>Organization:</strong> ${u.organization ? populatedValueOfReference(u.organization)?.name || "Yes" : "None"}<br>`
        }
        
        this.contentTextView.text = content
    }
    
    
    override layoutSubviews() {
        
        super.layoutSubviews()
        
        const padding = this.core.paddingLength
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        const textHeight = this.contentTextView.intrinsicContentHeight(bounds.width)
        
        bounds
            .rectangleWithHeight(Math.min(textHeight, 600))
            .assignedAsFrameOfView(this.scrollView)
            .rectangleForNextRow(padding, padding * 3)
            .distributeViewsEquallyAlongWidth([this.closeButton], 0)
        
        this.contentTextView.frame = this.scrollView.bounds.rectangleWithInset(padding)
        
    }
    
}
